/* IMPORT */
import { SYMBOL_OBSERVABLE_FROZEN, SYMBOL_OBSERVABLE_READABLE } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const isObservableFrozen = (value) => {
    return isFunction(value) && ((SYMBOL_OBSERVABLE_FROZEN in value) || !!value[SYMBOL_OBSERVABLE_READABLE]?.parent?.disposed);
};
/* EXPORT */
export default isObservableFrozen;
